import { useEffect, useState } from "react";
import { getCachedHelpCenter, getHelpCenter } from "../../Services/HelpCenter";
import type { IHelpCenter } from "../../interfaces/models/IHelpCenter";

type UseHelpCenterConfigResult = {
  config: IHelpCenter | null;
  error: string | null;
  isReady: boolean;
};

export function useHelpCenterConfig(
  errorMessage = "Failed to load the Help Center.",
): UseHelpCenterConfigResult {
  const [config, setConfig] = useState<IHelpCenter | null>(() =>
    getCachedHelpCenter(),
  );
  const [error, setError] = useState<string | null>(null);
  const [isReady, setIsReady] = useState(() => Boolean(getCachedHelpCenter()));

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const data = await getHelpCenter();
        if (!cancelled) {
          setConfig(data);
          setError(null);
        }
      } catch (loadError) {
        console.error("Failed to load help center", loadError);
        if (!cancelled) {
          setError(errorMessage);
        }
      } finally {
        if (!cancelled) {
          setIsReady(true);
        }
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [errorMessage]);

  return { config, error, isReady };
}
